"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDraggableInPortal = void 0;
const react_1 = require("react");
const react_dom_1 = require("react-dom");
// Source: https://github.com/atlassian/react-beautiful-dnd/issues/128#issuecomment-669083882
const useDraggableInPortal = () => {
    const self = (0, react_1.useRef)({}).current;
    (0, react_1.useEffect)(() => {
        const div = document.createElement("div");
        div.style.position = "absolute";
        div.style.pointerEvents = "none";
        div.style.top = "0";
        div.style.width = "100%";
        div.style.height = "100%";
        // @ts-ignore
        self.elt = div;
        document.body.appendChild(div);
        return () => {
            document.body.removeChild(div);
        };
    }, [self]);
    return (render) => (provided, ...args) => {
        const element = render(provided, ...args);
        if (provided.draggableProps.style.position === "fixed") {
            // @ts-ignore
            return (0, react_dom_1.createPortal)(element, self.elt);
        }
        return element;
    };
};
exports.useDraggableInPortal = useDraggableInPortal;
//# sourceMappingURL=useDraggableInPortal.js.map